import { render, staticRenderFns } from "./monthlyCarRenewalRecord.vue?vue&type=template&id=b63b5e02&scoped=true"
import script from "./monthlyCarRenewalRecord.vue?vue&type=script&lang=js"
export * from "./monthlyCarRenewalRecord.vue?vue&type=script&lang=js"
import style0 from "./monthlyCarRenewalRecord.vue?vue&type=style&index=0&id=b63b5e02&prod&scoped=true&lang=css"
import style1 from "./monthlyCarRenewalRecord.vue?vue&type=style&index=1&id=b63b5e02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63b5e02",
  null
  
)

export default component.exports